export interface IPlanogramIndicator {
	id?: number;
	name: string;
	type: 'WARNING' | 'ERROR' | 'MASTER_RULE';
	rule_name?: string;
}

export enum Indicators {
	PRODUCT_COMPRESSION_CHANGED = 'PLANOGRAMS_LIST.INDICATORS.UPDATE_COMPRESSION',
	PRODUCT_PARAMS_CHANGED = 'PLANOGRAMS_LIST.INDICATORS.UPDATE_PARAMETERS',
	PRODUCTS_DELETED = 'PLANOGRAMS_LIST.INDICATORS.DELETE_PRODUCTS',
	ETL_PRODUCT_UPDATE = 'PLANOGRAMS_LIST.INDICATORS.DAILY_UPDATE',
	PRODUCT_ROTATION = 'PLANOGRAMS_LIST.INDICATORS.PRODUCTS_ROTATION',
	PLANOGRAM_COPY = 'PLANOGRAMS_LIST.INDICATORS.PLANOGRAM_COPY',
	EQUIPMENT_CHANGED = 'PLANOGRAMS_LIST.INDICATORS.EDIT_EQUIPMENT',
	ARCHIVED_PRODUCTS = 'PLANOGRAMS_LIST.INDICATORS.ARCHIVED_PRODUCTS',
	UNARCHIVED_PRODUCTS = 'PLANOGRAMS_LIST.INDICATORS.UNARCHIVED_PRODUCTS',
	MASTER_RULE_APPLIED = 'PLANOGRAMS_LIST.INDICATORS.MASTER_RULE_APPLIED',
	MASTER_RULE_OUTDATED = 'PLANOGRAMS_LIST.INDICATORS.MASTER_RULE_OUTDATED'
}

export enum IndicatorsIcon {
	ERROR = 'error',
	WARNING = 'warning',
	MASTER_RULE = 'file'
}

export enum IndicatorsColor {
	ERROR = '#ff0000',
	WARNING = '#ffcc15',
	MASTER_RULE_APPLIED = '#39b54a',
	MASTER_RULE_OUTDATED = '#000000'
}

export type IndicatorVisual = {
	icon: string;
	color: string;
	tooltip: string;
	tooltipParams?: { rule_name: string };
};

export function resolveIndicatorVisual(indicator: IPlanogramIndicator): IndicatorVisual {
	const tooltip = Indicators[indicator.name] || indicator.name;
	const tooltipParams = { rule_name: indicator.rule_name || '' };

	if (indicator.type === 'MASTER_RULE') {
		return {
			icon: IndicatorsIcon.MASTER_RULE,
			color: IndicatorsColor[indicator.name] || IndicatorsColor.MASTER_RULE_OUTDATED,
			tooltip: tooltip,
			tooltipParams: tooltipParams
		};
	}

	return {
		icon: IndicatorsIcon[indicator.type],
		color: IndicatorsColor[indicator.type],
		tooltip: tooltip,
		tooltipParams: tooltipParams
	};
}
